import { render, staticRenderFns } from "./research-site-details.vue?vue&type=template&id=6a862eb7&scoped=true&"
import script from "./research-site-details.vue?vue&type=script&lang=js&"
export * from "./research-site-details.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=6a862eb7&scoped=true&lang=scss&"
import style1 from "@/assets/dropdown-css.scss?vue&type=style&index=1&id=6a862eb7&scoped=true&lang=scss&"
import style2 from "./research-site-details.vue?vue&type=style&index=2&id=6a862eb7&scoped=true&lang=scss&"
import style3 from "./research-site-details.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a862eb7",
  null
  
)

component.options.__file = "research-site-details.vue"
export default component.exports